import * as _ from "lodash";

var service = function () {
  var publishedStateDisplay = function (discount) {
    return (
      {
        enabled: "Published",
        draft: "Draft",
        paused: "Paused",
        deleted: "Deleted",
      }[(discount || {}).published_state] || "Draft"
    );
  };

  return {
    publishedStateDisplay: publishedStateDisplay,
  };
};

service.$inject = [];

tiz.service("Discount", service);
export default service;
